import { BaseViewStore } from 'core/stores';
import { action, observable } from "mobx";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { FacilityOrderTemplateItemService } from "application/facility-order/services";
import { ScheduleService } from 'application/schedule/services';
import _ from 'lodash';

class PickTicketInfoModalStore extends BaseViewStore {
    @observable accessor items;
    @observable accessor disabled = false;
    @observable accessor isLoading = false;
    @observable accessor isChanged = false;
    @observable accessor disabledSendOrder = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.disabledSendOrder = this.modalParams.data.disabledSendOrder;
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        this.fetch([this.initialize()]);
    }

    @action
    async initialize() {
        const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
        const response = await pickTicketHeaderService.getExcludedAndIncludedFacilityOrderTemplateItems(this.modalParams.data.facilityOrderId);
        this.sentSeparatelyItems = (await pickTicketHeaderService.getSentSeparatelyFacilityOrderTemplateItems(this.modalParams.data.facilityOrderId)).data.item;
        this.groupedSentSeparatelyItems = _.map(
            _.groupBy(this.sentSeparatelyItems, 'itemId'), (group, itemId) => ({
                itemId,
                itemName: group[0].itemName,
                sendSeparatelyQty: _.sumBy(group, 'sendSeparatelyQty'),
                totalQty: _.sumBy(group, 'totalQty')
            })
        );
        this.oldItems = _.map(response.data.item, i => { return i; });
        this.items = response.data.item;
        this.disabled = (!this.items || !this.items.some(x => x.id)) && (!this.sentSeparatelyItems || !this.sentSeparatelyItems.some(x => x.itemId));
        this.refreshPickTicket = this.modalParams.data.refreshPickTicket;
        let facilityScheduleDates = (await this.scheduleService.find({facilityOrderId: this.modalParams.data.facilityOrderId, fields: 'sendOrder'})).data.item;
        this.isOrderSent = facilityScheduleDates.every(x => x.sendOrder);
    }

    @action.bound
    async sendInfoEmail() {
        try {
            this.isLoading = true;
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            await pickTicketHeaderService.sendInfoEmail(this.modalParams.data.facilityOrderId);
            this.isLoading = false;
            this.rootStore.notificationStore.success("Pick Ticket email successfully sent.");
        }
        catch (err) {
            this.isLoading = false;
            let errorMessage = typeof err.data === "object" ? err.data.errorMessage : err.data;
            this.rootStore.notificationStore.error(errorMessage ? errorMessage : "PICK_TICKET_INFO.ERROR_EMAIL_SEND");
        }
    }

    @action.bound
    async setIncludeInPickTicket(item) {
        this.isChanged = false;
        item.includeInPickTicket = !item.includeInPickTicket;
        this.items.forEach(async (t) => {
            let oldItem = this.oldItems.find(x => x.id === t.id);
            if (oldItem && oldItem.includeInPickTicket != t.includeInPickTicket) {
                this.isChanged = true;
                return;
            }
        });

        var facilityOrderTemplateItem = (await this.facilityOrderTemplateItemService.get(item.id)).data;
        facilityOrderTemplateItem.includeInPickTicket = !facilityOrderTemplateItem.includeInPickTicket;
        await this.facilityOrderTemplateItemService.update(facilityOrderTemplateItem);
    }

    @action.bound
    async refreshPickTicketNewFlow() {
        if (this.refreshPickTicket) {
            await this.refreshPickTicket(this.modalParams);
        }
    }
}

export default PickTicketInfoModalStore;
